import propertyGroupsSlice from './propertyGroupsSlice';

export * from './thunks';

export default propertyGroupsSlice;
